module.exports = __webpack_public_path__ + "static/media/n06.e508bcb7.jpg";